export default __webpack_public_path__ + "static/media/chevron-right.18281368.svg";